(() => {
  angular
    .module('gm.common.ui')
    .directive('gmyScrollToTop', gmyScrollToTop);

  function gmyScrollToTop(
    $timeout
  ) {
    'ngInject';

    return {
      link,
      restrict: 'A',
    };

    function link(scope, element, attrs) {
      const offScroll = scope.$on(`scroll:${attrs.gmyScrollToTop}`, onScroll);

      function onDestroy() {
        offScroll();
      }

      function onScroll() {
        $timeout(() => {
          angular.element(element)[0].scrollTop = 0;
        });
      }

      scope.$on('$destroy', onDestroy);
    }
  }
})();
